import { EditIcon, TrashIcon } from "../components/kits/Icons";
import { NavLink } from "react-router-dom";
import useAxios from "../services/useAxios";
import CustomButton from "../components/kits/button/CustomButton";
import { useState, useEffect, useContext } from "react";
import TableCard from "../components/tableCard/TableCard";
import { addCommas } from "@persian-tools/persian-tools";
import ColorSchema from "../components/kits/Color";
import Helmet from "react-helmet";
import tst from "../assets/images/tst.png";
import Loader from "../utils/Loader";
import { searchFunc } from "../utils/helperFunction";
import SearchInputContext from "../Search/SearchInput";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";
import { swalFunc } from "../utils/helperFunction";

export default function List() {
  /**
   * TODO state
   */
  const { userInfo } = useContext(AuthenticationContext);

  const [loading, setLoading] = useState([true]);
  const [content, setContent] = useState([]);
  const [header, setHeader] = useState([
    {
      type: "img",
      title: "عکس",
      name: "path",
    },
    {
      type: "title",
      title: "عنوان",
      name: "title",
    },
    {
      type: "title",
      title: " قیمت  ",
      name: "price",
    },
    {
      type: "description",
      title: " توضیحات ",
      name: "description",
    },
    {
      type: "title",
      title: " مبلغ تخفیف  ",
      name: "discount",
    },
    // {
    //   type: "title",
    //   title: " امتیاز  ",
    //   name: "rate",
    // },
    {
      type: "title",
      title: " نوع محصول  ",
      name: "main_type",
    },
    {
      type: "operation",
      title: " عملیات ",
      name: "operation",
    },
  ]);
  const { execute: deactivate } = useAxios("api/Update_ProductServices");

  useEffect(() => {
    if (userInfo.userRoll.includes(3)) {
      let array = header;
      // array.push({
      //   type: "operation",
      //   title: " عملیات ",
      //   name: "operation",
      // });
      setHeader(array);
    }
  }, []);
  /**
   * TODO Api
   */
  const { execute: FindPr } = useAxios("api/Find_ProductServices");

  /**
   * TODO Function
   */
  const selectmain_type = (main_type) => {
    switch (main_type) {
      case "1":
        return "محصول نهایی";
        break;
      case "2":
        return "مواد اولیه";
        break;
      case "3":
        return "خدمت";
        break;
      case "4":
        return "تسک";
        break;

      default:
        return "نا مشخص";
        break;
    }
  };
  const returnJSX = (productId, data) => {
    console.log("object data", data);
    return (
      // <div className="d-flex justify-content-center">
      //   <NavLink to={`/product/${productId}`} target="_blank">
      //     <CustomButton className="shadow-none">
      //       <div
      //         onClick={() => {
      //           console.log("/productId", productId);
      //         }}
      //       >
      //         <EditIcon color={ColorSchema.primary_custom}></EditIcon>
      //       </div>
      //     </CustomButton>
      //   </NavLink>
      // </div>
      <div
        className="cursor-pointer"
        onClick={() => {
          swalFunc(
            `آیا از حذف محصول ${data.title} مطمئن هستید؟`,
            () =>
              deactivate({
                conditions: `id/=/${productId}`,
                keyvalues: `status,-1`,
              }).then((result) => {
                if (result.status == 1 || result.status == true)
                  setUpdateList((prev) => !prev);
              }),
            "warning"
          );
        }}
      >
        <TrashIcon color="tomato" />
      </div>
    );
  };
  const returnImg = (path) => {
    console.log("p", path);
    return (
      <div>
        {path ? (
          <img
            alt="عکس محصول"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
            }}
            src={`http://irancovercrmb.tatdemo.ir/${path}`}
          ></img>
        ) : (
          <img
            alt="عکس پیشفرض"
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            src={tst}
          ></img>
        )}
      </div>
    );
  };

  const [baseContent, setBaseContent] = useState([]);

  const { searchInput } = useContext(SearchInputContext);
  const [updateList, setUpdateList] = useState(false);

  // }, [])
  useEffect(() => {
    async function loadpage() {
      await FindPr({
        tbl_name: "left join,files,file_id,id",
        conditions: "status/=/0@@product_structure_id/!=/4",
      }).then((data) => {
        console.log("debug", data);
        setContent(data);
        setLoading(false);
        setBaseContent(data);
      });
    }
    loadpage();
  }, [updateList]);

  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      baseContent.map((value) => {
        return {
          ...value,
          id: value?.product_services__id,
          main_type_search: selectmain_type(value?.main_type),
        };
      })
    );
    setContent(temp);
  }, [searchInput]);

  return (
    <div>
      <Helmet>
        <title>لیست محصولات</title>
      </Helmet>
      {loading && <Loader />}
      {userInfo.userRoll.includes(2) && (
        <div className="mt-3 container d-flex">
          <NavLink
            to="/product/create"
            // target="_blank"
            style={{ textDecoration: "none" }}
          >
            <CustomButton
              color={"success"}
              size={"medium"}
              type={"base"}
              state={"normal"}
              circle={false}
            >
              افزودن محصول
            </CustomButton>
          </NavLink>
        </div>
      )}

      {userInfo.userRoll.includes(1) &&
        [...content].reverse().map((val, ind) => {
          return (
            <>
              {console.log("v.id", val.product_services__id)}
              <TableCard
                column={header}
                content={{
                  ...val,
                  path: returnImg(val.path),
                  main_type: selectmain_type(val.main_type),
                  operation: returnJSX(val.product_services__id, val),
                  price: `${addCommas(val.price)} تومان`,
                  discount: ` ${addCommas(val.discount)} تومان`,
                }}
                bg={"primary_light_custom"}
                widthParent={"80%"}
                showSelect="false"
              ></TableCard>
            </>
          );
        })}
    </div>
  );
}
